import React from "react";
import "../../styles/header.css";
// import Search from "../public/Search";

const Header = () => {
  return (
    <header className="header">
      <h1 className="cyf_title">Video Recommendation</h1>
      {/* <Search /> */}
    </header>
  );
};

export default Header;
